import { render, staticRenderFns } from "./selectedInfoList2.vue?vue&type=template&id=6824a8b9&"
import script from "./selectedInfoList2.vue?vue&type=script&lang=js&"
export * from "./selectedInfoList2.vue?vue&type=script&lang=js&"
import style0 from "./selectedInfoList2.vue?vue&type=style&index=0&lang=css&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports